export const getLikeCount = (like, count) => {
    const low = like ? 1 : 0
    return Math.max(low, count)
}
